
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/style",
      function () {
        return require("private-next-pages/style/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/style"])
      });
    }
  